@if (_entityTypesUsed.length > 0) {
  <mat-button-toggle-group
    id="entity-filters"
    name="selectEntity"
    aria-label="Select entity buttons"
    (change)="onFilterChange.emit($event.value)"
    hideSingleSelectionIndicator="true"
    [value]="value"
    >
    @if (_entityTypesUsed) {
      <mat-button-toggle value="" class="view-all" checked="{{ currentEntityFilter === '' }}">
        <mat-icon fontSet="material-icons-outlined">widgets</mat-icon>
        View All
        <aside>{{ totalOverride ? totalOverride : total }}</aside>
      </mat-button-toggle>
    }
    @for (entity of _entityTypesUsed; track entity) {
      <mat-button-toggle
        value="{{ entity.entity }}"
        [matTooltip]="entity.tooltip"
        matTooltipShowDelay="500"
        [ngClass]="[entity.entity ? entity.entity.toLowerCase() + '-entity' : '']"
        [style.--entity-counter-color]="getEntityColor(entity)"
        [style.--entity-hover-color]="getEntityColor(entity)"
        >
        @if (entity.iconUrl) {
          <app-salesforce-entity-icon
            [entityType]="entity.entity"
            [iconUrl]="entity.iconUrl"
            [iconColor]="entity.iconColor"
            [iconClass]="iconService.getIcon(entity.entity)"
            [tooltip]="entity.tooltip">
          </app-salesforce-entity-icon>
        } @else {
          <i class="{{ iconService.getIcon(entity.entity) }}"></i>
        }
        {{ entity.label }}
        <aside>{{ entity.count }}</aside>
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
}
